// I18N — App download banner strings translated.
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./AppDownloadBanner.css";

const APK_DOWNLOAD_URL = "/downloads/sokaab-app.apk";

const AppDownloadBanner = () => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Show banner after a short delay
    const timer = setTimeout(() => {
      setIsReady(true);
      setIsExpanded(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleMinimize = () => {
    setIsExpanded(false);
  };

  const handleExpand = () => {
    setIsExpanded(true);
  };

  if (!isReady) {
    return null;
  }

  // Minimized state - small floating button
  if (!isExpanded) {
    return (
      <button
        className="app-download-banner app-download-banner--minimized"
        onClick={handleExpand}
        aria-label={t("app.showLabel")}
      >
        <i className="fa-solid fa-mobile-screen-button"></i>
        <span>{t("app.getApp")}</span>
      </button>
    );
  }

  // Expanded state - full banner
  return (
    <div className="app-download-banner">
      <div className="app-download-banner__content">
        <button
          className="app-download-banner__close"
          onClick={handleMinimize}
          aria-label={t("app.minimizeLabel")}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>

        <div className="app-download-banner__icon">
          <i className="fa-solid fa-mobile-screen-button"></i>
        </div>

        <div className="app-download-banner__text">
          <h4>{t("app.title")}</h4>
          <p>{t("app.subtitle")}</p>
        </div>

        <a
          href={APK_DOWNLOAD_URL}
          download
          className="app-download-banner__button"
        >
          <i className="fa-solid fa-download"></i>
          {t("app.download")}
        </a>
      </div>
    </div>
  );
};

export default AppDownloadBanner;
